import { Position } from '../../types/protocol.js';
import { RecordPositionBase } from '../../types/record.js';
import { RecordWithProtocolBase } from '../../types/recordWithProtocol.js';


interface ResultItem<ObjectIdType> {
    recordPosition: RecordPositionBase<ObjectIdType>;
    record: RecordWithProtocolBase<ObjectIdType>;
    partIndex: number;
    hasMultipleParts: boolean;
}

export function extractPositionForSpc<ObjectIdType>(
    position: Position,
    records: RecordWithProtocolBase<ObjectIdType>[],
): ResultItem<ObjectIdType>[] {
    const positionNumber = position.positionNumber;

    const out: ResultItem<ObjectIdType>[] = [];
    for (const record of records) {
        if (record.isDraft) continue;

        const position = record.protocol.positions.find(it => it.positionNumber === positionNumber);
        if (!position) continue;
        if (position.type === 'visualInspection') continue;
        if (position.type === 'generalInspection') continue;
        if (position.nominal != position.nominal) continue;

        for (const [index, part] of record.parts.entries()) {
            const recordPos = part.positionValues.find(it => it.positionNumber === positionNumber);
            if (!recordPos) continue;

            out.push({
                recordPosition: recordPos,
                record,
                partIndex: index,
                hasMultipleParts: record.parts.length > 1,
            });
        }
    }
    return out;
}
